(ns dashboard.views.logout
  (:require [re-frame.core :as rf]
            [dashboard.subs :as subs]))

(defn logout-page []
  (let [heading @(rf/subscribe [::subs/view.page-heading])]
    [:div.section>div.columns>div.column.is-two-thirds.is-offset-one-fifth
     [:p.title heading]
     [:form
      [:div.notification "Confirm Logout"]
      [:div.level
       [:div.level-left
        [:button.button.is-success.is-rounded
         {:on-click #(.back js/window.history)
          :type "button"} "Cancel"]]
       [:div.level-right
        [:a.button.is-danger.is-rounded
         {:href "/authentication/logout"
          :type "button"} "Logout"]]]]]))
